module.exports = __webpack_public_path__ + "static/media/proxxmu-cover.1e37a58c.png";